import React from 'react'
import PropTypes from 'prop-types'
import { isBrowser, isTablet } from 'react-device-detect'

import { ScreenHeader } from '../../../../../../components/generic'
import PdfExport from '../../../../../../components/pdf/PdfExport'
import Glyph from '../../../../../../LEGACY/Glyph'
import { ButtonOLD } from '@lmc/ui-kit'

export default function MedStockHeader(props) {
  const {
    isPDF,
    startDate,
    endDate,
    item,
    medication,
    openStockLogModal,
    resident,
    router,
  } = props

  const title = isPDF
    ? `${resident.name.first} ${resident.name.last} - ${medication.name}`
    : `Stock - ${medication.name}`
  const subtitle = isPDF && `Stock Count`
  const pdfUrl = `residents/${router.params.id}/pdf/emar/${
    router.params.medication_id
  }/stock?printpdf=1&startDate=${startDate?.toISOString()}&endDate=${endDate?.toISOString()}`
  const url = `/api/services/pdf/export?url=${encodeURIComponent(pdfUrl)}`

  return (
    <ScreenHeader
      backLink={!isPDF}
      router={router}
      title={title}
      subtitle={subtitle}
      isInnerChildren
      useGoBack
    >
      {!isPDF && (
        <div style={styles.pdfBtn}>
          <PdfExport
            pdfTitle="Stock Count"
            url={url}
            text={isDesktop ? 'Download PDF' : 'PDF'}
          />
        </div>
      )}
      {!isPDF && (
        <ButtonOLD
          id="add-stock-log-button"
          onClick={() =>
            openStockLogModal({
              resident: router.params.id,
              medication: router.params.medication_id,
              item: item.id,
              category: item.category,
            })
          }
          style={styles.addMedicationButton}
          type="primary"
          icon={<Glyph name="plus" />}
          // disabled={home && !home.features?.emarOnboarded?.enabled && !chartData.length}
        >
          Stock Count
        </ButtonOLD>
      )}
    </ScreenHeader>
  )
}

MedStockHeader.propTypes = {
  isPDF: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  item: PropTypes.object,
  medication: PropTypes.object.isRequired,
  openStockLogModal: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
}

const isDesktop = isBrowser || isTablet

const styles = {
  pdfBtn: {
    marginRight: 8,
  },
}
